import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage, getAvatarPresenterFromPage } from '@/pages/AdvancedEditor/utils';
import { Divider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { AvatarView, getMaskingType } from '.';
import { BorderControl } from './BorderControl';
import { FillControl } from './FillControl';
import { ShadowControl } from './ShadowControl';

export const AvatarMaskingCircleControls = observer(() => {
    const { store } = useAdvancedEditorContext();

    const avatarElement = getAvatarElementFromPage(store.activePage);
    const presenter = getAvatarPresenterFromPage(store.activePage);

    if (!avatarElement || !presenter) return null;

    const isAvatarMaskingCircle = getMaskingType(avatarElement) === AvatarView.Circle;

    return (
        <>
            {isAvatarMaskingCircle && (
                <>
                    <Divider />

                    <FillControl />

                    <BorderControl />

                    <ShadowControl />
                </>
            )}
        </>
    );
});
